function validateInternalUser(email: string): boolean {
  const list = ['@syngenta.com', 'strider', 'teste', 'imagery', 'protector'] as const;
  return list.some((item) => email.includes(item));
}

export { validateInternalUser };
